import type * as Style from '../../index.js'

export const Props = <T extends Style.Type = Style.Type>(props: any = {}) => ({
  type: props.type as T
})
export type Props<T extends Style.Type = Style.Type> = ReturnType<typeof Props<T>>
export const validate = () => true
export const fix = (props: Props, styles: Style.Rule[]) => props
export const label = 'Collection'
export const type = 'collection'
export const category = 'basic'
export const forms = [] as Style.Form[]
